import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardActions, CardContent, Grid, Modal, Typography } from '@material-ui/core';
import { themeActions } from '../_actions/theme.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: '30px 0',
  },
  modal: {
    position: 'absolute',
    width: 400,
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  buttonsContainer: {
    justifyContent: 'flex-end'
  },
  modalButton: {
      width: 100
  }
}));

export default function DeleteButton({message, buttonText, onDelete}) {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  return (
    <div>
        <Grid container justifyContent="flex-start">
          <Button
            color="secondary"
            className={classes.button}
            onClick={() => setShowModal(true)}
            size="small"
            startIcon={<FontAwesomeIcon icon={['fas', 'trash']} />}
            variant="text"
          >
            {buttonText}
          </Button>
        </Grid>

        <Modal
            disableAutoFocus
            disableEnforceFocus
            onClose={() => setShowModal(false)}
            open={showModal}
        >
            <Card className={classes.modal}>
                <CardContent>
                    <Typography gutterBottom variant="h6" align="left">
                        {message}
                    </Typography>
                </CardContent>
                <CardActions className={classes.buttonsContainer}>
                    <Button size="small" variant="contained" className={classes.modalButton} onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button size="small" color="secondary" variant="contained" className={classes.modalButton} onClick={() => {
                      onDelete()
                      setShowModal(false)
                    }}>
                        Excluir
                    </Button>
                </CardActions>
            </Card>
        </Modal>
    </div>
  );
}